(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[46],{

/***/ 2705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(5639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 4239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705),
    getRawTag = __webpack_require__(9607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 1957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 9607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(2705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 3218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 7005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 7620:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Category/[catId]",
      function () {
        return __webpack_require__(1133);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1133:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Category; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_masonry_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(827);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2679);
/* harmony import */ var react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7040);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(1382);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(2986);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7294);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4246);
/* harmony import */ var react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(react_lazy_load_image_component_src_effects_blur_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3338);
/* harmony import */ var components_Navigation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2433);
/* harmony import */ var components_Picture__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(472);
/* harmony import */ var utils_constant__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4807);
/* harmony import */ var services_PicturesAPI__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(5110);
/* harmony import */ var services_CategoriesAPI__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(3301);



















var Category = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(Category, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(Category);
    function Category(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(this, Category);
        var _this;
        _this = _super.call(this, props);
        _this.loadImages = _this.loadImages.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this));
        _this.loadCategories = _this.loadCategories.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this));
        _this.handleRouteChange = _this.handleRouteChange.bind((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(_this));
        _this.state = {
            categoryName: "All Category",
            categories: [],
            images: [],
            latestUrl: "",
            loading: true
        };
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)(Category, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.loadCategories();
                this.loadImages();
                next_router__WEBPACK_IMPORTED_MODULE_1___default().events.on("routeChangeComplete", this.handleRouteChange);
            }
        },
        {
            key: "handleRouteChange",
            value: function handleRouteChange(url) {
                var latestUrl = this.state.latestUrl;
                // console.log('currentURL', url);
                // console.log('latestURL', latestUrl);
                if (url.toString().includes("Category") && !latestUrl.includes("Pictures")) {
                    var _this = this;
                    this.setState({
                        images: [],
                        latestUrl: url,
                        loading: true
                    }, function() {
                        _this.loadImages();
                    });
                } else {
                    this.setState({
                        latestUrl: url
                    });
                }
            }
        },
        {
            key: "loadImages",
            value: function loadImages() {
                var _this = this;
                var query = this.props.query;
                (0,services_PicturesAPI__WEBPACK_IMPORTED_MODULE_11__/* .activePicturesByCategory */ .$9)(query.catId).then(function(response) {
                    _this.setState({
                        images: response.data,
                        loading: false
                    });
                });
            }
        },
        {
            key: "loadCategories",
            value: function loadCategories() {
                var _this = this;
                (0,services_CategoriesAPI__WEBPACK_IMPORTED_MODULE_12__/* .activeCategories */ .fq)().then(function(response) {
                    _this.setState({
                        categories: response.data
                    });
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var query = this.props.query;
                var _state = this.state, images = _state.images, categoryName = _state.categoryName, categories = _state.categories, loading = _state.loading;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "cover",
                            style: {
                                backgroundImage: "url(".concat(utils_constant__WEBPACK_IMPORTED_MODULE_10__/* .baseURL */ .v, "public/cover/cover.jpg)")
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Navigation__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "content",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: categoryName
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "category-container",
                                    children: categories.map(function(item) {
                                        var name = item.category_name;
                                        var active = query.catId === name ? "active" : "";
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                            href: "/Category/[catId]?catId=".concat(name),
                                            as: "/Category/".concat(name),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                className: "category-link ".concat(active),
                                                children: name
                                            })
                                        }, name);
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                    centered: true,
                                    visible: !!query.id,
                                    onCancel: function() {
                                        return next_router__WEBPACK_IMPORTED_MODULE_1___default().push("/Category/[catId]?catId=".concat(query.catId), "/Category/".concat(query.catId));
                                    },
                                    footer: null,
                                    bodyStyle: {
                                        padding: 0
                                    },
                                    children: query.id && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Picture__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                        id: query.id,
                                        modal: true
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    style: {
                                        marginTop: "5%"
                                    },
                                    children: [
                                        loading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            size: "large"
                                        }),
                                        !loading && images.length === 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {}),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_masonry_css__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                            breakpointCols: {
                                                default: 4,
                                                1100: 3,
                                                700: 2,
                                                500: 1
                                            },
                                            className: "my-masonry-grid",
                                            columnClassName: "my-masonry-grid_column",
                                            children: images.map(function(item) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    href: "/Category/[catId]?catId=".concat(query.catId, "&id=").concat(item.pic_id),
                                                    as: "/Pictures/".concat(item.pic_id),
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load_image_component__WEBPACK_IMPORTED_MODULE_4__.LazyLoadImage, {
                                                            style: {
                                                                width: "100%",
                                                                marginBottom: 20
                                                            },
                                                            delayTime: 0,
                                                            threshold: 100,
                                                            alt: item.pic_title,
                                                            crossOrigin: "anonymous",
                                                            effect: "blur",
                                                            className: "img-card img-card-hover",
                                                            placeholderSrc: "".concat(utils_constant__WEBPACK_IMPORTED_MODULE_10__/* .baseURL */ .v).concat(item.pic_image, "-thumb.jpeg"),
                                                            src: "".concat(utils_constant__WEBPACK_IMPORTED_MODULE_10__/* .baseURL */ .v).concat(item.pic_image, "-comp.jpeg")
                                                        }, item.pic_id)
                                                    })
                                                }, item.pic_id);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ], [
        {
            key: "getInitialProps",
            value: function getInitialProps(param) {
                var query = param.query;
                return {
                    query: query
                };
            }
        }
    ]);
    return Category;
}(react__WEBPACK_IMPORTED_MODULE_5__.Component);



/***/ }),

/***/ 3301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dg": function() { return /* binding */ saveCategories; },
/* harmony export */   "PF": function() { return /* binding */ removeCategories; },
/* harmony export */   "fq": function() { return /* binding */ activeCategories; },
/* harmony export */   "kb": function() { return /* binding */ listCategories; }
/* harmony export */ });
/* harmony import */ var _BaseAPI__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5836);

function listCategories(searchKeyword, page, limit) {
    var formData = new FormData();
    formData.append("keyword", searchKeyword);
    formData.append("page", page);
    formData.append("limit", limit);
    return (0,_BaseAPI__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("Categories/list", formData);
}
function saveCategories(data) {
    var formData = new FormData();
    formData.append("category_name", data.category_name);
    formData.append("category_name_old", data.id);
    formData.append("category_status", data.category_status ? 1 : 0);
    return (0,_BaseAPI__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("Categories/save", formData);
}
function removeCategories(categoryName) {
    var formData = new FormData();
    formData.append("category_name", categoryName);
    return (0,_BaseAPI__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("Categories/remove", formData);
}
function activeCategories() {
    var formData = new FormData();
    return (0,_BaseAPI__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)("Categories/activeList", formData);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [885,982,107,488,577,803,40,890,995,768,774,888,179], function() { return __webpack_exec__(7620); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);